import BaseToggleButton from '@material-ui/lab/ToggleButton'

const ToggleButton = BaseToggleButton

export default ToggleButton
